/**
 *  23/03/2020 v 1.0 - JuanMa
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  30/07/2021 Añadida propiedad usarFiltros35: PropTypes.bool,
 *                   En método Load, al crear el filtro de mayor que cero, tenemos en cuent la propiedad usarFiltro35
 *                   En método Load, obtenemos los datos del response o del response.lo según se usen Filtros35
 *                   Modificado el método getDerivedStateFromProps para solo cambiar las propiedades si existen en nextProps.elementos
 * v.2.2  03/08/2021 Añadido set({¢argandoDatos:true}) en método Load.
 * v.2.3  18/08/2021 Añadido let claseSimple= clase; en método load.
 *
 * v.2.4  06/05/2021 Fusionado Planifikator y Sidemur
 * v.2.5  25/07/2022 Añadida propiedad gridColumnasAdicionales para incluir nuevas columnas.
 *                   En Render corregido el tipo de la columna por defecto a CELLTIPO_CADENA.
 *                   En Render añadido el push de las gridColumnasAdicionales
 * v.2.6  29/07/2022 Añadida la propiedad anchoColumna
 * v.2.7  19/10/2022 Añadida propiedad onPropiedadesServicio
 *                   División de load entre loadDeServidor y loadDeServicioServidor
 * v.2.8  28/02/2023 En loadDeServidor cambiada la forma de insertar las condiciones
 **/

import React from 'react'
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import Grid from "../../../framework2/blueprint/Grid";
import * as Classes from "@blueprintjs/core/lib/esm/common/classes";
import {Button, Dialog, FormGroup, InputGroup, Intent, Spinner, Tooltip} from "@blueprintjs/core";
import ClienteRestful from "../network/ClienteRestful";
import {getFiltroFromCampo, getFiltroInicialFromCampoFECHAPERIODO} from "../utils/FiltroGridUtils";
import {FILTRO_MAYOR, FILTRO35_MAYOR} from "./FormularioGridBusqueda";
import {filtrarConNombreCampo} from "../utils/FilterUtils";
import GridRDG from "../../adazzle/GridRDG";
import {CELLTIPO_CADENA} from "./TiposCeldas";



class DialogoSelectorLista extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            opened: props.opened,
            titulo: props.titulo,
            clase: props.clase,
            elementos: props.elementos ? props.elementos : [],
            cargandoDatos: false,
            gridColumnaCampo: props.gridColumnaCampo,
            gridColumnaTitulo: props.gridColumnaTitulo,
            datoSelected: props.datoSelected,
            noMostrarCero: true,
        }
    }


    componentDidMount() {
        const {clase, elementos} = this.props;

        if (!elementos && clase){
            this.load();
        }
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.opened !== prevState.opened) {
            newState.opened = nextProps.opened;
        }
        if (nextProps.elementos && nextProps.elementos !== prevState.elementos) {
            console.log("nextProps.elementos: ", nextProps.elementos);
            newState.elementos = nextProps.elementos;
        }
        if (nextProps.datoSelected && nextProps.datoSelected !== prevState.datoSelected) {
            newState.datoSelected = nextProps.datoSelected;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    onSelectedRow= (row) => {
        const {elementos} =  this.state;
        let elemento= elementos[row];
        this.setState({datoSelected: elemento});
    }


    onAcceptedRow= (datoAccepted) => {
        this.setState({datoSelected: datoAccepted}, ()=> { this.onAceptar()});
    }

    onCancelar= () => {
        const {onCancelado} = this.props;
        onCancelado && onCancelado();
    }

    onAceptar= () => {
        const {datoSelected} =  this.state;
        const {onAceptado} = this.props;
        onAceptado && onAceptado(datoSelected);
    }

    load= () => {
        const {onPropiedadesServicio} = this.props;

        //console.log("DialogSelectorLista - Load");
        //console.log("onPropiedadesServicio: ", onPropiedadesServicio);

        if (!onPropiedadesServicio)
            this.loadDeServidor();
        else
            this.loadDeServidorServicio();
    }

    loadDeServidor = () => {
        const {noMostrarCero, clase, gridColumnaCampo} = this.state;
        const {urlServicioRestful, condiciones, usarFiltros35} = this.props;

        let claseSimple= clase;
        if (clase) {
            let pos = clase.lastIndexOf(".") + 1;
            if (pos > 0)
                claseSimple = clase.substr(pos);
        }
        const url= urlServicioRestful + "list/" + claseSimple;

        /*
        console.log("DialogoSelectorLista");
        console.log("LOAD");
        console.log("url: ", url);
        console.log(noMostrarCero);
        */

        this.setState({cargandoDatos: true});

        //console.log(url);
        const clienteRestful = new ClienteRestful().setUrl(url);

        var filtro= {condiciones: [], orden: []};
        /* ANTES
        condiciones && condiciones.forEach ( (campo) => {
            if (campo.valor)  {
                let filtroCampo = getFiltroFromCampo(campo, campo.valor, campo.valor2);
                if (filtroCampo)
                    filtro.condiciones.push(filtroCampo);
            }

            if (campo.tipoValor){
                let filtroCampo=  getFiltroInicialFromCampoFECHAPERIODO(campo);
                if (filtroCampo)
                    filtro.condiciones.push(filtroCampo);
            }
        });
        */
        //AHORA:
        condiciones && condiciones.forEach ( (condicion) => {
            filtro.condiciones.push(condicion);
        });

        console.log("filtro: ", filtro);

        //Añadimos condicion de cero inmutable
        //console.log(noMostrarCero);
        if (noMostrarCero){
            //console.log("NON CERO")
            if (usarFiltros35)
                filtro.condiciones.push( {nombreCampo: "codigo", tipo: FILTRO35_MAYOR,  valor: 0} );
            else
                filtro.condiciones.push( {nombreCampo: "codigo", tipo: FILTRO_MAYOR,  valor: 0} );
        }

        //Ordenamos alfabéticamente
        filtro.orden.push({nombreCampo: gridColumnaCampo, asc:true})

        console.log("filtro: ", filtro);

        clienteRestful.doPost( filtro, response => {
            if (clienteRestful.exito && response){
                console.log("response: ", response);

                let newElementos= response;
                if (usarFiltros35)
                    newElementos= response.lo;

                this.setState({cargandoDatos: false, elementos: newElementos}, () => {
                    this.asignarElementoSeleccionado();
                });

            }
        });
    }

    loadDeServidorServicio = () => {
        const {urlServicioRestful, onPropiedadesServicio} = this.props;
        const url= urlServicioRestful;
        const clienteRestful = new ClienteRestful().setUrl(url);

        console.log("DIALOGOSELECTORLISTA - LoadDeServidorServicio");
        console.log(url);

        let propiedadesServicio= onPropiedadesServicio && onPropiedadesServicio();

        console.log("propiedades: ", propiedadesServicio);

        clienteRestful.doPost( propiedadesServicio, response => {
            if (clienteRestful.exito && response){
                console.log(response);
                let newElementos= response;

                this.setState({cargandoDatos: false, elementos: newElementos}, () => {
                    this.asignarElementoSeleccionado();
                });

            }
        });

    }


    asignarElementoSeleccionado= () => {
        const {valor, elementos, campoValor} = this.state;
        //console.log("asignarElementoSeleccionado:");
        //console.log("elementos: ", elementos);

        if (elementos && elementos.length > 0){
            let coincidentes= filtrarConNombreCampo(elementos, campoValor, valor);
            if (coincidentes && coincidentes.length > 0){
                this.setState({elementoSeleccionado: coincidentes[0]});
            }

        }
    }



    render() {
        const {opened,  elementos, clase,  cargandoDatos, gridColumnaCampo, gridColumnaTitulo, datoSelected} =  this.state;
        const {tipoGrid, gridColumnasAdicionales, anchoColumna} = this.props;

        let columnas = [
            {campo: gridColumnaCampo, titulo: gridColumnaTitulo, tipo: CELLTIPO_CADENA, ancho: anchoColumna ? anchoColumna : '200px'},
        ];
        if (gridColumnasAdicionales)
            gridColumnasAdicionales.forEach((columnaAdicional)=>  columnas.push(columnaAdicional) );

        return (
            <div>

                <Dialog
                    icon="info-sign"
                    onClose={this.onCancelar}
                    title= {"Selección"}
                    isOpen={opened}
                    usePortal= {true}
                    canOutsideClickClose={false}
                    //style={{ width: "50%"}}
                    autofocus={true}
                >
                    <div className={Classes.DIALOG_BODY} style={{height:270}}>
                        { cargandoDatos && <Spinner intent={Intent.PRIMARY} size={50} /> }

                        {(!cargandoDatos && elementos && (!tipoGrid || tipoGrid !== "reactdatagrid")) &&
                            <Grid columnas={columnas} datos={elementos}
                                  onSelectedRow={this.onSelectedRow}
                                  onAcceptedRow={this.onAcceptedRow}
                                  ordenable={false}
                                  estilo={{height: '230px'}}
                                  mostrarEncabezado={false}
                                  elementoSeleccionado={datoSelected}
                            />
                        }
                        {(!cargandoDatos && elementos && (tipoGrid && tipoGrid === "reactdatagrid")) &&
                            <GridRDG id={"DialogoSelector"}
                                     estilo={{height: '230px'}}
                                     columnas={columnas} datos={elementos}
                                     onSelectedRow={this.onSelectedRow}
                                     ordenable={true}
                                     rowKey={"codigo"}
                                     mostrarHeaderRow={false}
                                     onRowSelectedReturn={ this.onAcceptedRow}
                                     rowClickedIsReturn={true}
                            />

                        }


                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Tooltip content="Aceptar">
                                <Button intent={Intent.SUCCESS} icon="tick-circle" onClick={this.onAceptar}>Aceptar</Button>
                            </Tooltip>
                            <Tooltip content="Cancelar">
                                <Button intent={Intent.DANGER} icon="delete" onClick={this.onCancelar}>Cancelar</Button>
                            </Tooltip>
                        </div>
                    </div>
                </Dialog>
            </div>



        );
    }

}



DialogoSelectorLista.propTypes = {
    //datos: PropTypes.array.isRequired,
    campoNombre: PropTypes.string,
    gridColumnaCampo: PropTypes.string,
    gridColumnaTitulo: PropTypes.string,
    datoSelected: PropTypes.object,
    onCancelado: PropTypes.func,
    OnAceptado: PropTypes.func,

    clase: PropTypes.string,
    urlServicioRestful: PropTypes.string,
    usarFiltros35: PropTypes.bool,

    tipoGrid: PropTypes.string,
    gridColumnasAdicionales: PropTypes.array,
    anchoColumna: PropTypes.string,

    onPropiedadesServicio: PropTypes.func,
}


export default DialogoSelectorLista

